export class MeetTheTeamModel {

    public searchTerm: string = "";
    public teams: TeamModel[] = [];
    
} 

export class TeamModel {

    public id: number;
    public name: string;
    public members: TeamMemberModel[] = [];

}

export class TeamMemberModel {

    public id: number;
    public teamId; number;
    public name: string;
    public position: string;
    public bio: string;
    public email: string;
    public chat: string;
    public phoneWork: string;
    public phonePrivate: string;
    public memberSince: string;
    public address: string;

}